// Page-load entry: third-party / heavy widgets that depend on external libs (Swiper etc.).
// Loaded separately from effect.js so the site-wide UI modules stay independent of CDN libs.
import { initTopSwiper } from './modules/swiper-top';
import { initVoiceSwiper } from './modules/swiper-voice';
import { initCf7Redirect } from './modules/cf7-redirect';

window.addEventListener('load', () => {
  initTopSwiper();
  initVoiceSwiper();
  initCf7Redirect();
});
